/**
 * @ngdoc filters
 */
module
    .filter('trustAsHtml', ['$sce', function ($sce) {
        'use strict';
        return function (content) {
            return $sce.trustAsHtml(typeof content === 'string'?content:'');
        };
    }])
    // Display price in euro
    .filter('toCurrency', function () {
        'use strict';
        return function (input) {
            if (isNaN(input)) {
                return input;
            }
            return Number(input).toFixed(2).replace('.', ',') + '€';
        };
    })
    .filter('toBoolean', function () {
        'use strict';
        return function (content) {
            return content === '1';
        };
    })
    .filter('firstCap', function () {
        'use strict';
        // in : hey a GREAT string !
        // out : Hey a GREAT string !
        return function (content) {
            // return empty string if not defined
            if (!content || content === null || content === '') {
                return '';
            }
            // to work with string
            content = (content + '');
            // to upper first & keep rest
            content = content[0].toUpperCase() + content.slice(1);
            return content;
        };
    })
    .filter('slugify', function () {
        'use strict';
        return function (content) {
            if (!content) {
                return '';
            }
            var to = 'aaaaeeeeiiiioooouuuunc-------';
            var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;&';
            var str = content.trim();
            var i;
            var l = from.length;

            str = str.toLowerCase();
            for (i = 0; i < l; i += 1) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }
            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes
            return str;
        };
    })
    .filter('translate', ['$rootScope', 'translation', function($rootScope, translation) {
        'use strict';
        return function(input) {
            if (angular.isUndefined(input) || null === input || '' === input) {
                return '';
            }

            var keys = input.split('.');
            var value = translation[$rootScope.config.language];
            for (var i = 0, count = keys.length; i < count; ++i) {
                if (value.hasOwnProperty(keys[i])) {
                    value = value[keys[i]];
                } else {
                    value = input + ' (no translation)';
                    break;
                }
            }

            return value;
        };
    }])
    .filter('toDate', ['moment', function (moment) {
        return function (date, format) {
            return moment(date).format(format);
        };
    }])
    .filter('limitFromTo', function() {
        /**
         * @name limitFromTo
         * @by Sven Anders Robbestad, 2013
         * @license CC0 1.0 Universal (CC0 1.0)
         * @description
         * Limit From-To filter for AngularJS.
         * Creates a new array or string containing only a specified number of elements with an extra
         * parameter specifying the starting point..
         * The elements are taken from either the beginning or the end of the source array or string, as
         * specified by the value and sign (positive or negative) of `limit`.
         *
         * Usage:
         * <div ng-repeat="data in array|limitFromTo:2:8"></div>
         * Returns a copy of the array with the remaining elements from the selected position. In the example above, the div will be populated with 6 elements from position 2.
         *
         */
        return function(input, offset, limit) {
            if(!(input instanceof Array) && !(input instanceof String)) return input;

            limit = parseInt(limit,10);

            if (input instanceof String) {
                if (limit) {
                    return limit >= 0 ? input.slice(offset, limit) : input.slice(limit, input.length);
                } else {
                    return "";
                }
            }

            var out = [], i, n;

            if (limit > input.length) {
                limit = input.length;
            } else if (limit < -input.length) {
                limit = -input.length;
            }

            if (limit > 0) {
                i = offset;
                n = limit;
            } else {
                i = input.length + limit;
                n = input.length;
            }

            for (; i<n; i++) {
                out.push(input[i]);
            }

            return out;
        };
    })
    .filter('injectVars', [ 'tools', function (tools) {
        'use strict';

        return tools.replace;
    }])
    .filter('orderIntershipList', ['$filter', function ($filter) {
        return function (items, field) {
            if (!Array.isArray(items)) return items;
            if (!field) return items;

            // EVO 8 - Pouvoir forcer l’ordre d’affichage des bases (https://redmine.niji.fr/issues/45176)
            if (field === 'basename' || field === '-basename') {
                var reverseOrder = (field === '-basename');
                var filtered = [];

                angular.forEach(items, function (item) {
                    filtered.push(item);
                });

                filtered.sort(function (a, b) {
                    var valueA = a.base.weight;
                    var valueB = b.base.weight;

                    if (valueA !== null && valueB !== null) {
                        return (valueA === valueB ?
                            0 :
                            valueA > valueB ?
                                (!reverseOrder ? 1 : -1) :
                                (!reverseOrder ? -1 : 1)
                            );
                    } else if (valueA === null && valueB === null) {
                        valueA = a.base.name;
                        valueB = b.base.name;
                        return !reverseOrder ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
                    } else if (valueA !== null && valueB === null) {
                        return !reverseOrder ? -1 : 1;
                    } else if (valueA === null && valueB !== null) {
                        return !reverseOrder ? 1 : -1;
                    }
                });

                return filtered;
            } else {
                return $filter('orderBy')(items, field);
            }
        };
    }]);
